import { GoogleDocLegalPage } from './legal/GoogleDocLegalPage';
import { LEGAL_DOCUMENTS } from './legal/legalDocuments';

export const TermsOfService = () => <GoogleDocLegalPage document={LEGAL_DOCUMENTS.termsOfService} />;
